import axios from "axios";
import {environment} from "../environment";
import {IMultiGymInfo} from "../store/multiGyms/multiGymsSlice";

class MultiGymServiceClass {

     async getFranchiseGyms(token: string) {
         let config: any = {};
         if (token) {
             config.headers = {
                 Authorization: `Bearer ${token}`,
             }
         }
         return axios.get<{success: boolean, data: IMultiGymInfo[]}>(`${environment.authServer}api/v2/franchises/franchise-gyms?franchiseId=${environment.franchiseId}`, config);
     }

}

export const MultiGymService = new MultiGymServiceClass();